import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useThemeMode } from '../../contexts/ThemeContext';
import LanguageSwitcher from '../common/LanguageSwitcher';

function Header() {
  const navigate = useNavigate();
  const { mode, toggleTheme } = useThemeMode();
  const { t } = useTranslation('common');

  const handleHomeClick = () => {
    navigate('/');
  };

  const bgColor = mode === 'dark' ? '#1f1f1f' : '#f5f5f5';
  const textColor = mode === 'dark' ? '#ffffff' : 'rgba(0, 0, 0, 0.87)';
  const iconButtonSx = { color: textColor };

  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        width: '100%',
        bgcolor: bgColor,
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          minHeight: 56,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          onClick={handleHomeClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            cursor: 'pointer',
            color: textColor,
            flexGrow: 1,
            flexBasis: 0,
            minWidth: 0,
          }}
        >
          <Typography
            variant="h6"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: '1rem',
              color: 'inherit',
              m: 0,
            }}
          >
            ⚙️ {t('appTitle')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            justifyContent: 'flex-end',
            color: textColor,
            ml: 'auto',
          }}
        >
          <LanguageSwitcher />

          <Tooltip title={mode === 'light' ? 'Activate dark mode' : 'Activate light mode'}>
            <IconButton color="inherit" onClick={toggleTheme} size="large" sx={iconButtonSx}>
              {mode === 'light' ? <DarkModeIcon /> : <Brightness7Icon />}
            </IconButton>
          </Tooltip>

          <IconButton color="inherit" onClick={handleHomeClick} size="large" sx={iconButtonSx}>
            <HomeIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
